<template>
    <div>
        <h3>
            Цвет заднего фона
        </h3>
        <div class="mt-2 flex items-center">
            <color-picker format="hex8" v-model:pureColor="backgroundStyle.color"/>
            <button type="button"
                    v-if="!isColorTransparent()"
                    @click="setTransparentColor"
                    class="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Сделать прозрачным
            </button>
        </div>
    </div>
</template>

<script>
import VueShortToggle from "@/scripts/components/app/common/vue-short-toggle.vue";
import {ColorPicker} from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    name: "BackgroundStyle",
    components: {
        VueShortToggle,
        ColorPicker,
    },

    computed: {
        ...mapState(qrCodeFormStore, ['style']),
        backgroundStyle: {
            get() {
                return this.style.backgroundStyle;
            },
            set(val) {
                this.updateBackgroundStyle(val);
            },
        }
    },

    mounted() {
        this.isTransparent = this.backgroundStyle.type === 'transparent'
    },

    watch: {
        isTransparent(val) {
            this.backgroundStyle.type = val ? 'transparent' : 'color'
        }
    },

    data() {
        return {
            isEnable: false,
            isTransparent: false,
        }
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateBackgroundStyle']),
        setTransparentColor() {
            this.backgroundStyle.color = '#ffffff00'
        },
        isColorTransparent() {
            return this.backgroundStyle.color === '#ffffff00';
        }
    }
}
</script>

<style scoped>

</style>
